module.exports = __WEBPACK_EXTERNAL_MODULE_297__;


//////////////////
// WEBPACK FOOTER
// external "comsMobx"
// module id = 297
// module chunks = 66